import { Mail, Phone, Globe, Code2, Brain, Zap, Database, Palette, Smartphone, ShoppingCart, Accessibility, Users, Rocket, Cloud, Linkedin, Paintbrush } from 'lucide-react';
import SaveContact from './SaveContact';

const ContactCard = ({ person }) => {
  const services = [
    { name: 'Software Development', icon: Code2, url: 'https://www.fidlogic.com/custom-software-development' },
    { name: 'AI and ML App Development', icon: Brain, url: 'https://www.fidlogic.com/ai-app-development' },
    { name: 'IoT App Development', icon: Zap, url: 'https://www.fidlogic.com/iot-app-development' },
    { name: 'Blockchain Services', icon: Rocket, url: 'https://www.fidlogic.com/blockchain-services' },
    { name: 'Cloud and Infrastructure', icon: Cloud, url: 'https://www.fidlogic.com/cloud-app-development' },
    { name: 'DevOps Services', icon: Zap, url: 'https://www.fidlogic.com/devops-services' },
    { name: 'Data Engineering', icon: Database, url: 'https://www.fidlogic.com/data-engineering' },
    { name: 'Web Development', icon: Globe, url: 'https://www.fidlogic.com/web-app-development'},
    { name: 'Mobile App Development', icon: Smartphone, url: 'https://www.fidlogic.com/mobile-app-development' },
    { name: 'eCommerce App Development', icon: ShoppingCart, url: 'https://www.fidlogic.com/ecommerce-app-development' },
    { name: 'Digital Design', icon: Palette, url: 'https://www.fidlogic.com/ui-and-ux-design' },
    { name: 'UI and UX Design', icon: Paintbrush, url: 'https://www.fidlogic.com/ui-and-ux-design' },
    { name: 'MVP Development', icon: Rocket, url: 'https://www.fidlogic.com/mvp-development' },
    { name: 'SaaS App Development', icon: Code2, url: 'https://www.fidlogic.com/saas-development' },
    { name: 'Digital Accessibility Services', icon: Accessibility, url: 'https://www.fidlogic.com/digital-accessibility' },
    { name: 'Dedicated Team Augmentation', icon: Users, url: 'https://www.fidlogic.com/staff-augmentation-services' },
  ];

  const products = [
    { 
      name: 'On-Demand-Coder', 
      url: 'https://ondemandcoder.fidlogic.com',
      image: '/assets/OnDemandCoder.png',
      description: 'On-demand coding solutions'
    },
    { 
      name: 'Capture-For-Testers', 
      url: 'https://www.capturefortesters.com',
      image: '/assets/CaptureForTesters.png',
      description: 'Test management and collaboration platform'
    },
  ];

  return (
    <div className="App">
      <div className="contact-card">
        {/* Animated Background Elements */}
        <div className="background-elements">
          <div className="glow-blob glow-blob-1"></div>
          <div className="glow-blob glow-blob-2"></div>
          <div className="glow-blob glow-blob-3"></div>
        </div>

        {/* Profile Header */}
        <div className="profile-header">
          <div className="profile-avatar">
            <img 
              src="/assets/Logo - only - no bg - 336X336.png" 
              alt="FidLogic Logo"
              className="avatar-logo"
            />
            <div className="avatar-glow"></div>
          </div>
          <h1 className="profile-name">{person.name}</h1>
          <p className="profile-designation">{person.designation}</p>
          <p className="profile-company">{person.company}</p>
        </div>

        {/* Contact Information */}
        <div className="contact-info">
          <div className="info-item">
            <Globe size={20} className="info-icon" />
            <a href={`https://${person.website}`} target="_blank" rel="noopener noreferrer">
              {person.website}
            </a>
          </div>
          <div className="info-item">
            <Mail size={20} className="info-icon" />
            <a href={`mailto:${person.email}`}>{person.email}</a>
          </div>
          <div className="info-item">
            <Phone size={20} className="info-icon" />
            <a href={`tel:${person.phone}`}>{person.phone}</a>
          </div>
          <div className="info-item">
            <Linkedin size={20} className="info-icon" />
            <a href={person.linkedin} target="_blank" rel="noopener noreferrer">
              {person.linkedinText}
            </a>
          </div>
        </div>

        {/* Save Contact Button */}
        <div className="save-contact-section">
          <SaveContact person={person} />
        </div>

        {/* Products Section */}
        <div className="section products-section">
          <h2 className="section-title">
            <Rocket size={24} className="title-icon" />
            Our Products
          </h2>
          <div className="products-grid">
            {products.map((product, index) => (
              <a
                key={index}
                href={product.url}
                target="_blank"
                rel="noopener noreferrer"
                className="product-card"
              >
                {/* <img 
                  src={product.image} 
                  alt={product.name}
                  className="product-image"
                /> */}
                <div className="product-content">
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-description">{product.description}</p>
                  <div className="product-arrow">→</div>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Services Section */}
        <div className="section services-section">
          <h2 className="section-title">
            <Zap size={24} className="title-icon" />
            Our Services
          </h2>
          <div className="services-grid">
            {services.map((service, index) => {
              const IconComponent = service.icon;
              return (
                <a
                  key={index}
                  href={service.url} 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="service-card"
                >
                  <div className="service-icon-wrapper">
                    <IconComponent size={32} className="service-icon" />
                  </div>
                  <p className="service-name">{service.name}</p>
                </a>
              );
            })}
          </div>
        </div>

        {/* Social Links */}
        <div className="social-links">
          <a href="https://www.facebook.com/people/FidLogic-It-Solutions/61569795726933/" target="_blank" rel="noopener noreferrer" className="social-link">
            <img src="/assets/facebook.png" alt="Facebook" className="social-icon" />
          </a>
          <a href="https://www.instagram.com/fidlogic/" target="_blank" rel="noopener noreferrer" className="social-link">
            <img src="/assets/instagram.png" alt="Instagram" className="social-icon" />
          </a>
          <a href="https://www.linkedin.com/company/fidlogic/" target="_blank" rel="noopener noreferrer" className="social-link">
            <img src="/assets/linkedin.png" alt="LinkedIn" className="social-icon" />
          </a>
          <a href="https://x.com/FidLogicIT" target="_blank" rel="noopener noreferrer" className="social-link">
            <img src="/assets/x_32x32.png" alt="Twitter" className="social-icon" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
